<template>
  <div>
    <header class="hero is-fullheight is-primary is-medium">
      <div class="hero-body">
        <div class="single-spaced weird-margin">
          <h1 class="title is-1 has-text-white">
            BeatCaps
          </h1>
          <h2 class="subtitle is-4 has-text-white">
            Transcribe rhythm.
          </h2>
          <router-link
            to="/demo"
            class="button is-medium is-danger is-inverted is-rounded is-outlined has-text-weight-bold"
            style="width: 100%; border: 0.15em solid white;"
          >
            Try Demo
          </router-link>
        </div>
      </div>
    </header>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-two-thirds">
            <h2 class="title">
              What are BeatCaps?
            </h2>
            <p>
              A new form of transcription specifically for music that uses AI to
              bring multi-sensual experiences to streaming media. Our patented
              solution is the only way to add <strong>zero-latency</strong> rhythmic experiences
              compliant with web standards. It's also the <strong>easiest</strong> way for
              streaming platforms to make audible music accessible to Deaf users.
              Since it uses web standards, it can be <strong>infinitely customized</strong> to
              create vibrations, visualizations, and more.
            </p>
            <br>
            <router-link
              to="/demo"
              class="button is-medium middle is-danger is-inverted is-rounded is-outlined has-text-weight-bold has-text-black"
              style="width: 100%; border: 0.15em solid black;width: 18rem;"
            >
              Try Demo
            </router-link>
          </div>
          <figure class="image is-one-third">
            <img
              alt="Signed music performance"
              src="/img/5756561933_af5596209e_n.jpg"
            >
          </figure>
        </div>
      </div>
    </section>
    <section class="section has-background-light">
      <div class="container">
        <!-- <h2 class="title">Applications</h2> -->
        <div class="columns">
          <div class="column">
            <div class="notification music-background is-black">
              <h1 class="title">
                Music
              </h1>
            </div>
          </div>
          <div class="column">
            <div class="notification exercise-background is-white">
              <h1 class="title">
                Exercise
              </h1>
            </div>
          </div>
          <div class="column">
            <div class="notification musicals-background is-black">
              <h1 class="title">
                Musicals
              </h1>
            </div>
          </div>
          <div class="column">
            <div class="notification dance-background is-black">
              <h1 class="title">
                Dance
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section has-background-dark has-text-white has-text-centered">
      <div class="container">
        <h2 class="title">
          Partners
        </h2>
        <p>
          We're always looking for new partners in the tech community and the deaf community. Please contact us to get involved!
        </p>
        <br>
        <div class="button-container">
          <a
            href="mailto:info@beatcaps.io"
            class="button is-medium has-text-dark has-background-white is-inverted is-rounded is-outlined has-text-weight-bold"
            style="border: 0.15em solid white;"
          >Contact Us</a>
          <!-- Comment button in once partner page is created -->
          <router-link
            to="/partners"
            class="button is-medium has-text-white has-background-dark is-inverted is-rounded is-outlined has-text-weight-bold"
            style="border: 0.15em solid white;"
          >
            Learn More
          </router-link>
        </div>

        <partner-logos label-classes="has-text-white" />
      </div>
    </section>
    <section class="section has-background-light">
      <div class="container">
        <div class="columns">
          <div class="column is-two-thirds">
            <h2 class="title">
              We'll work how you work
            </h2>
            <p>
              Whether you want an integrated solution or you want to use our cloud, BeatCaps works with
              you. We follow industry standards to work on any video viewer that supports closed
              captioning.
            </p>
            <br>
            <p>
              <a
                href="mailto:info@beatcaps.io"
                class="button is-medium middle is-danger is-inverted is-rounded is-outlined has-text-weight-bold has-text-black"
                style="width: 18rem; border: 0.15em solid black;"
              >Contact Us</a>
            </p>
          </div>
          <figure class="image is-one-third">
            <img
              alt="microphone"
              src="/img/jonathan-velasquez-160775-unsplash.jpg"
            >
          </figure>
        </div>
      </div>
    </section>
    <!-- Ideas:
    https://www.templatemonster.com/landing-page-template/leylo-singer-landing-page-template-79603.html
    https://trint.com/
    -->
  </div>
</template>

<script>
import PartnerLogos from '../components/PartnerLogos.vue'

export default {
  name: 'LandingPage',
  components: { PartnerLogos },
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {
    this.$emit('theme', 'dark')
  },
  methods: {}
}
</script>
<style>
.section-left {
  text-align: left;
  margin-top: 1rem;
}
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)),
    url("/img/audience-concert-crowd-1677710-min.jpg") center / cover;
}
.music-background {
  background: url(/img/applause-audience-band-167636.jpg) center / cover;
}
.exercise-background {
  background: url(/img/active-activity-adult-863926.jpg) center / cover;
}
.musicals-background {
  background: url(/img/asphalt-brasil-concrete-843256.jpg) center / cover;
}
.dance-background {
  background: url(/img/action-adult-dance-270837.jpg) center / cover;
}
.notification {
  min-height: 30vh;
}
.button-container {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
}

/* bulma helpers */
.center,
.center-column,
.top,
.right,
.bottom,
.left {
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-column {
  flex-direction: column;
}

.top {
  align-items: flex-start;
}
.right {
  justify-content: flex-end;
}
.bottom {
  align-items: flex-end;
}
.left {
  justify-content: flex-start;
}

.single-spaced,
.single-spaced * {
  line-height: 1;
}
.title {
  color: inherit;
}
.title.is-1 {
  font-size: 4rem;
}

.weird-margin {
  margin-left: 10vw;
}

@media (max-width: 1024px) {
  .desktop {
    display: none;
  }
}
</style>
